import {
  faArrowLeft,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";
import { downgradeAccount } from "../../redux/actions/userActivity";
import _ from "lodash";
import { countAllCertificates } from "../../redux/actions/certificate";

const DowngradeModal = ({
  setIsModalEnabled,
  setScrollToProMonthly,
  setIsToggle,
  setActivePricingId,
}) => {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const email = useSelector((store) => store?.profileDetails?.email);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [certificateCount, setCertificateCount] = useState({});

  const freePlanPerks = [
    {
      text: "Free Learning Access",
      isChecked: true,
    },
    {
      text: "Job Support",
      isChecked: false,
    },
    {
      text: "Certificates",
      isChecked: false,
    },
    {
      text: "Access to 900+ Hiring Partners",
      isChecked: false,
    },
    {
      text: "Live Workshops",
      isChecked: false,
    },
    {
      text: "Practical Projects",
      isChecked: false,
    },
  ];

  useEffect(() => {
    dispatch(
      countAllCertificates(
        (successObj) => {
          console.log("response", successObj);
          setCertificateCount(successObj);
        },
        (errObj) => {},
      ),
    );
  }, []);

  console.log(certificateCount);
  if (step1) {
    return (
      <Dialog
        open={true}
        onClose={() => null}
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="relative z-10 flex  w-[95%] flex-col items-center justify-center overflow-auto rounded-xl bg-white py-2 px-4 text-center shadow-2xl  md:w-1/4 md:p-4 lg:w-[28%]">
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src="https://img.learntube.ai/public-assets/8_day_journey/downgradeOption.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1669702226246"
            transformation={[
              {
                height: "150",
                width: "150",
              },
            ]}
            className="h-44 w-44"
          />
          <h1 className="text-xl font-bold">
            Are you sure, {user_name?.split(" ")?.[0]}?
          </h1>
          <div className="mt-4 grid w-full  grid-cols-2 gap-2">
            {freePlanPerks.map((item) => (
              <div className="flex items-center justify-start text-sm">
                {item?.isChecked ? (
                  <FontAwesomeIcon
                    icon={faCheck}
                    className={"mr- text-[#2ECC71]"}
                    size="xl"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faTimes}
                    className={"mr-1 text-[#FF2633]"}
                    size="xl"
                  />
                )}
                <p className="ml-1 text-left text-xs md:text-sm">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="mt-2 flex w-full items-center justify-center">
            <button
              className="my-3 mr-1 rounded-lg border-2 border-[#13B284] px-2 py-2 text-sm font-medium text-[#13B284] focus:outline-none md:text-sm"
              onClick={() => {
                Mixpanel.track(Constants.Mixpanel.WALL_DOWNGRADE_2, {
                  distinct_id: email,
                });
                setStep1(false);
                setStep2(false);
              }}
            >
              Downgrade & Lose Career Growth
            </button>
            <button
              className="my-3 ml-1 rounded-lg bg-[#13B284] px-4 py-2 text-sm font-medium text-white md:text-sm"
              onClick={() => {
                Mixpanel.track(Constants.Mixpanel.WALL_EXPLORE_ALL, {
                  distinct_id: email,
                });
                setIsModalEnabled(false);
              }}
            >
              Explore Premium & Grow Career
            </button>
          </div>
        </div>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={true}
        onClose={() => null}
        as="div"
        style={{ zIndex: "9999999999" }}
        className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
      >
        <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
        <Dialog.Title />
        <Dialog.Description />
        <div className="relative z-10 flex  w-[95%] flex-col items-center justify-center overflow-auto rounded-xl bg-white py-4 px-4 text-center shadow-2xl  md:w-1/4 md:p-4 lg:w-[28%]">
          <FontAwesomeIcon
            icon={faArrowLeft}
            size="lg"
            onClick={(e) => {
              setStep2(false);
              setStep1(true);
            }}
            className="self-start"
          />
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src="https://img.learntube.ai/public-assets/PRICING/37e4874d11f5f5be1267a36acaccc834_2.gif?ik-sdk-version=javascript-1.4.3&updatedAt=1678108230016"
            transformation={[
              {
                height: "150",
                width: "150",
              },
            ]}
            className="h-20 rounded-lg"
          />
          <h1 className="mt-2 text-xl font-bold">
            {" "}
            {user_name?.split(" ")?.[0]},
          </h1>
          <h1 className="text-xl font-bold">Don’t Lose Your Certificates!</h1>
          <div className="mt-2 text-sm">
            Upon downgrading, you will{" "}
            <span className="font-bold ">lose access</span> to all of your{" "}
            <span className="text-pricing_blue">
              {" "}
              {certificateCount?.mskill_certificate_count +
                certificateCount?.skill_certificates_count}{" "}
              completed course certificates.
            </span>
          </div>
          <img
            urlEndpoint="https://img.learntube.ai/public-assets/"
            src="https://img.learntube.ai/public-assets/PRICING/Group_7143.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1677655955616"
            transformation={[
              {
                height: "150",
                width: "150",
              },
            ]}
            className="h-20"
          />
          <p className="my-1 text-sm">
            For the price of just{" "}
            <span className="font-semibold">1 coffee/month</span> do you really
            want to <span className="font-semibold">risk lakhs</span> worth of
            career growth?
          </p>
          <div className="mt-2 flex w-full flex-col items-center justify-center">
            <div className="flex w-full items-center justify-center">
              <button
                className="mt-3 mr-1  w-1/2 rounded-lg border-2 border-[#13B284]  py-2  text-sm font-medium text-[#13B284] focus:outline-none md:w-1/2 md:text-sm"
                onClick={() => {
                  Mixpanel.track(Constants.Mixpanel.WALL_EXPLORE_ALL, {
                    distinct_id: email,
                  });
                  setStep1(false);
                  setStep2(false);
                  setIsModalEnabled(false);
                }}
              >
                Explore All Plans
              </button>
              <button
                className="mt-3 ml-1 w-1/2 whitespace-nowrap rounded-lg border-2 border-[#13B284]  bg-[#13B284] py-2 text-sm font-medium text-white md:w-1/2 md:text-sm"
                onClick={() => {
                  Mixpanel.track(Constants.Mixpanel.WALL_UNLOCK, {
                    distinct_id: email,
                  });
                  setIsModalEnabled(false);
                  setIsToggle(true);
                  setActivePricingId(1);
                }}
              >
                Unlock All Certificates
              </button>
            </div>
            <div className="mr-6 mt-1 self-end text-xs font-medium">
              @₹299 for 1 Month
            </div>
          </div>
          <div
            className="mt-2 cursor-pointer text-sm font-medium text-[#E5303E] underline"
            onClick={(e) => {
              Mixpanel.track(Constants.Mixpanel.WALL_DOWNGRADE_3, {
                distinct_id: email,
              });
              dispatch(
                downgradeAccount((successObj) => {
                  setIsModalEnabled(false);
                  // setIsCareerGoal()
                }),
              );
            }}
          >
            Downgrade Anyway
          </div>
        </div>
      </Dialog>
    );
  }
};

export default DowngradeModal;
